<template>
	<div
		class="image"
		:style="ratio"
	>
		<img
			:src="src"
			loading="lazy"
			v-if="loaded"
		>
		<div
			class="placeholder"
			v-if="!loaded">
		</div>
	</div>
</template>

<script>

export default {
	props: {
		src: {
			type: String,
			default: null
		},
		ratioWidth: {
			type: Number,
			default: 3
		},
		ratioHeight: {
			type: Number,
			default: 2
		}
	},

	data () {
		return {
			loaded: false
		}
	},

	computed:  {
		ratio () {
			return {
				paddingBottom: this.ratioHeight / this.ratioWidth * 100 + '%'
			}
		}
	},

	mounted () {
		var image = new Image()

		image.onload = () => {
			this.loaded = true
		}

		image.src = this.src
	}
}
</script>

<style scoped>
.image {
	position: relative;
	overflow: hidden;
	width: 100%;
	height: 1px;
}

.image img {
	position: absolute;
	top: 0;
	left: 0;
}

.image .placeholder {
	background-color: #ededed;
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
}
</style>
